var app = angular.module("leonardo");

var PropertyTemplatesStates = function($stateProvider) {
  $stateProvider.state('property.templates', {
    url: "/templates",
    title: 'Templates',
    cssClass: 'page-template-list',
    templateMode: 'property',
    views: {
      'title@authenticated.layout-main': { template: '<h1>Templates that apply to {{ filterService.currentProperty.name }}</h1>' },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/template/list.html',
        controller: 'TemplateList'
      },
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/template-list.html',
        controller: 'TemplateListActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/task/filters.html',
        controller: 'PropertyTasksFilters'
      }
    },
    ncyBreadcrumb: {
      label: 'Templates'
    }
  });

  $stateProvider.state('property.templates.edit', {
    url: "/:pk/edit",
    params: {
      pk: '',
      squash: false
    },
    cssClass: 'page-template-edit',
    views: {
      'title@authenticated.layout-main': { template: '<h1>Template edit</h1>'},
      'actions@authenticated.layout-main': {},
      'filters@authenticated.layout-main': {},
      'content@authenticated.layout-main': {
        controller: 'TemplateForm',
        templateUrl: 'views/templates/template/form.html'
      }
    },
    resolve: {
      templateObj: ['TemplateService', '$stateParams', function(TemplateService, $stateParams) {
        return TemplateService.get($stateParams.pk);
      }]
    },
    ncyBreadcrumb: {
      label: 'Template edit'
    }
  });

  $stateProvider.state('property.templates.add', {
    url: "/add?origin",
    cssClass: 'page-template-edit',
    templateMode: 'property',
    action: 'create',
    views: {
      'title@authenticated.layout-main': { template: '<h1>Add Template</h1>'},
      'actions@authenticated.layout-main': {},
      'filters@authenticated.layout-main': {},
      'content@authenticated.layout-main': {
        controller: 'TemplateForm',
        templateUrl: 'views/templates/template/form.html'
      }
    },
    resolve: {
      templateObj: ['TemplateService', 'AccountService', 'AccountUserService', 'FilterService',
        function(TemplateService, AccountService, AccountUserService, FilterService) {
          if (FilterService.currentProperty) {
            return TemplateService.bulkObject(FilterService.currentProperty.account &&
              FilterService.currentProperty.account.id ? FilterService.currentProperty.account.id :
              FilterService.currentProperty.account);
          }
          else if (AccountUserService.currentAccountUser) {
            return TemplateService.bulkObject(AccountUserService.currentAccountUser.account);
          }
          else {
            return TemplateService.bulkObject(null);
          }
      }]
    },
    ncyBreadcrumb: {
      label: 'Add Template'
    }
  });
};

app.config(['$stateProvider', PropertyTemplatesStates]);
